import { lazy, Suspense } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { useWebContext } from '@/resources/hooks/useWebContext';
import { ApplicationState } from '@/store';
import { setCartAlertAfterBuy } from '@/store/ducks/customer/actions';

const IdentifyBy = lazy(() => import('../cart/shipment/client/IdentifyBy'));

interface Props {
  show: boolean;
  setShow: (show: boolean) => void;
}

function IdentificationModal({ show, setShow }: Props) {
  const dispatch = useDispatch();
  const { order, configs, setShowCartAlertModal } = useWebContext();

  const selectCartAlertWasAskedAfterBuy = useSelector<ApplicationState, boolean>(
    (state) => state.customer.asks.cart_alert_after_buy,
  );

  const showCartAlert2 = () =>
    configs.has_cart_alert && !selectCartAlertWasAskedAfterBuy && order?.cart.products.length === 1;

  const handleCloseIdentificationModal = () => {
    setShow(false);

    if (showCartAlert2()) {
      setShowCartAlertModal(true);
      dispatch(setCartAlertAfterBuy(true));
    }
  };

  return (
    <>
      {order && (
        <Modal
          id="cart-identification-modal"
          show={show}
          onHide={handleCloseIdentificationModal}
          animation={false}
          size="lg"
          centered={true}
        >
          <Suspense fallback={<div />}>
            <IdentifyBy orderId={order.id} closeModal={handleCloseIdentificationModal} />
          </Suspense>
        </Modal>
      )}
    </>
  );
}

export default IdentificationModal;
